import type { Components, Theme } from '@mui/material'

const button: Components<Omit<Theme, 'components'>>['MuiButton'] = {
  defaultProps: {
    disableRipple: true,
    disableElevation: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: theme.functions.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium,
      borderRadius: theme.borders.borderRadius['md'],
      minWidth: 'auto',
      variants: [
        ...['primary', 'secondary', 'success', 'warning', 'error'].map((color) => ({
          props: {
            variant: 'outlined',
            color,
          },
          style: {
            backgroundColor: theme.alpha(theme.palette[color].main, 0.1),
            '&:hover': {
              backgroundColor: theme.alpha(theme.palette[color].main, 0.15),
            },
          },
        })),
        {
          props: {
            variant: 'contained',
          },
          style: {
            border: '1px solid currentColor',
            borderColor: 'var(--variant-containedBg, currentColor)',
            '&.Mui-disabled': {
              borderColor: theme.palette.action.disabledBackground,
            },
          },
        },
        {
          props: {
            size: 'medium',
          },
          style: {
            padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
          },
        },
        {
          props: {
            size: 'small',
          },
          style: {
            padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
            lineHeight: 1.5,
          },
        },
      ],
    }),
  },
}

export default button
